// extracted by mini-css-extract-plugin
export default {"container":"SsoPage_container__pUPjz","iframe":"SsoPage_iframe__v4F+7"};